<template>
  <v-card outlined >
    <v-card-title class="py-3">
      <span class="text-subtitle-1 font-weight-bold">
        Reembolsos
      </span>

      <v-spacer />
    </v-card-title>

    <v-divider />

    <v-card-text class="pa-3">
      <v-alert
        v-if="error"
        type="error"
        dense
        outlined
        class="mb-3"
      >
        {{ error }}
      </v-alert>

      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        loading-text="Cargando reembolsos..."
        no-data-text="No se encontraron reembolsos"
        class="elevation-1"
        dense
        :items-per-page="5"
      >
        <template v-slot:[`item.Monto`]="{ item }">
          {{ formatCurrency(item.Monto) }}
        </template>

        <template v-slot:[`item.FechaGasto`]="{ item }" >
          {{ formatDate(item.FechaGasto) }}
        </template>

        <template v-slot:[`item.created_at`]="{ item }" >
          {{ formatDateTime(item.created_at) }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'TablaReembolsos',

  props: {
    id: {
      type: [String, Number],
      default: null
    },

    autoLoad: {
      type: Boolean,
      default: true
    },
    reloadTrigger: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      loading: false,
      error: null,
      items: [],
      headers: [
        {
          text: 'ID Reembolso',
          value: 'IdReembolso',
          align: 'start'
        },
        {
          text: 'Folio',
          value: 'Folio'
        },
        {
          text: 'Tipo',
          value: 'Tipo'
        }
        ,
        {
          text: 'Descripción',
          value: 'Descripcion'
        },
        {
          text: 'Monto',
          value: 'Monto',
          align: 'end'
        },
        {
          text: 'Fecha gasto',
          value: 'FechaGasto'
        }

      ]
    }
  },

  watch: {
    id: {
      immediate: true,
      handler(value) {
        if (this.autoLoad && value) {
          this.consultar()
        } else {
          this.items = []
        }
      }
    },
    reloadTrigger() {
      if (this.id) {
        this.consultar()
      }
    }
  },

  methods: {
    async consultar() {
      if (!this.id) {
        this.error = 'No se recibió un ID válido.'
        this.items = []
        return
      }

      this.loading = true
      this.error = null

        this.$http.get(`Reembolso/${this.id}`)
          .then(response => {
            if (response.status === 200) {
              if (response.data) {
                this.items  = response.data
              }
            }
          })
          .catch(() => {
        }).finally(() => {
            this.loading = false
        });

    },

    formatCurrency(value) {
      if (value === null || value === undefined || value === '') return '$0.00'

      return Number(value).toLocaleString('es-MX', {
        style: 'currency',
        currency: 'MXN'
      })
    },

    formatDate(value) {
      if (!value) return ''

      return new Date(value).toLocaleDateString('es-MX', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
    },

    formatDateTime(value) {
      if (!value) return ''

      return new Date(value).toLocaleString('es-MX', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  }
}
</script>